import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StoreService {
    private static store: Map<string, any>;

    /** @deprecated usage of key 'ua' is deprecated, you must use methods of UaService instead */
    public static get(key: 'ua'): any;
    public static get(key: string): any;
    public static get(key: string): any {
        if (!StoreService.store) {
            StoreService.store = new Map<string, any>();
        }
        return StoreService.store.get(key);
    }

    public static set(key: string, value: any): void {
        if (!StoreService.store) {
            StoreService.store = new Map<string, any>();
        }
        StoreService.store.set(key, value);
    }

    public static has(key: string): boolean {
        if (!StoreService.store) {
            StoreService.store = new Map<string, any>();
        }
        return StoreService.store.has(key);
    }
}
